module.exports = __webpack_public_path__ + "img/report.7aa20c28.png";